import { z } from 'zod'

export const NL_NL = 'nl_NL'
export const EN_US = 'en_US'

export const locale = z.enum([NL_NL, EN_US])

export const locales = Object.values(locale.enum)

export type Locale = z.infer<typeof locale>
